import { ModalContent } from "../../../types/common";
import { ConfirmAlertModal } from "./ConfirmAlertModal";
import styles from "../../../assets/scss/common/modal/confirmAlertModal.module.scss";
import React, { useCallback } from "react";
import {useTranslation} from "react-i18next";

interface Props {
  content: ModalContent;
  showAlertModal: boolean;
  closeAlertModal: (e: React.MouseEvent) => void;
}

export function AlertModal({ content, showAlertModal, closeAlertModal }: Props) {
  const {t} = useTranslation("modal");
  const Buttons = useCallback(
    () => (
      <button
        className={styles.alertBtn}
        onClick={(e: React.MouseEvent) => {
          closeAlertModal(e);
          content.callback?.();
        }}
      >
        {t("confirm")}
      </button>
    ),
    [closeAlertModal, content, t]
  );

  return <ConfirmAlertModal showModal={showAlertModal} content={content} buttons={<Buttons />} />;
}
